import Vue from 'vue';
import Vuex from 'vuex';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import userModule from './modules/user/userModule';
import routeModule from './modules/routing/routeModule';
import subsidiaryModule from './modules/subsidiary/subsidiaryModule';
import costCenterModule from './modules/costCenter/costCenterModule';

Vue.use(Vuex);

const store = new Vuex.Store(
	{
		modules: {
			costCenter: { namespaced: true, ...costCenterModule },
			route: { namespaced: true, ...routeModule },
			subsidiary: { namespaced: true, ...subsidiaryModule },
			user: { namespaced: true, ...userModule },
		},
		state: {
			appConfig: {
				isLoading: false,
				snackbar: {
					text: '',
					isVisible: false,
					color: 'primary',
				},
			},
		},
		actions,
		getters,
		mutations,
	},
);

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js